import React, { useContext, useEffect, useState } from "react";

import RightArrow from "../../resources/rightArrow";
import { SVTUserContext } from "../../utils/SVTUserContext";
import { useTranslation } from "react-i18next";

const ArrowBox = ({ level, isLast }) => {
    const { t } = useTranslation();
    const [statusKey, setStatusKey] = useState("inProgress");
    const { activeLevelId, assessmentResult, assessmentData, scores } =
        useContext(SVTUserContext);
    const isActive = activeLevelId === level.levelId;

    useEffect(() => {
        fetchStatus();
        getStatusColor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scores, activeLevelId]);

    const fetchStatus = () => {
        const { basicScore, developingScore, matureScore } = scores;
        let score = 0;

        switch (level.levelId) {
            case 1:
                score = basicScore;
                break;
            case 2:
                score = developingScore;
                break;
            case 3:
                score = matureScore;
                break;
            default:
                setStatusKey("yetToStart");
                return;
        }

        if (score === 100) {
            setStatusKey("completed");
        } else if (score === 0 && !isActive && level.levelId !== 1) {
            setStatusKey("yetToStart");
        } else {
            setStatusKey("inProgress");
        }
    };

    const getStatusColor = () => {
        switch (statusKey) {
            case "inProgress":
                return "level-status in-progress";
            case "completed":
                return "level-status completed";
            case "yetToStart":
                return "level-status yet-to-start";
            default:
                return "level-status yet-to-start";
        }
    };
    return (
        <div className={`arrow-box ${isActive ? "activeArrowBox" : ""}`}>
            <div className="box-content">
                <h2 className="level-name">{t(level.levelName.toLowerCase())}</h2>
                <div className={getStatusColor()}>{t(statusKey)}</div>
            </div>
            {!isLast && (
                <div className="arrow-right">
                    <RightArrow isActive={isActive} />
                </div>
            )}
        </div>
    );
};

export default ArrowBox;
